// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconEdit = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="currentColor"
                d="M8.97890604,10.5002933 L1.47890604,10.5002933 L1.47890604,3.00029325 L5.13749993,3.00029325 L6.63749993,1.50029325 L1.47890604,1.50029325 C0.671484232,1.50029325 0,2.17177749 0,3.00029325 L0,10.5002933 C0,11.328809 0.671484232,12.0002933 1.47890604,12.0002933 L8.95781243,12.0002933 C9.78609359,12.0002933 10.4367188,11.328809 10.4367188,10.5002933 L10.4367188,5.34169936 L8.95772088,6.84146476 L8.95772088,10.5002933 L8.97890604,10.5002933 Z M11.6695307,0.989121437 L11.0102338,0.329589844 C10.5707806,-0.109863281 9.85851538,-0.109863281 9.41929615,0.329589844 L8.51414001,1.23498058 L10.7643746,3.48521519 L11.6695307,2.57982445 C12.1101562,2.14084053 12.1101562,1.42857456 11.6695307,0.989121437 Z M3.45234382,6.43154311 L3.00609398,8.66326189 C2.96676564,8.86004305 3.14027381,9.0335741 3.33703136,8.99419928 L5.56898475,8.54794908 C5.67787528,8.52615952 5.77785981,8.47264409 5.85632837,8.39415193 L10.2344534,4.0160265 L7.98421884,1.76579261 L3.60468757,6.14560604 C3.52734375,6.2229495 3.47343743,6.32373047 3.45234382,6.43154311 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(IconEdit);
